export default __webpack_public_path__ + "static/media/photo.82c30aba.svg";